module.exports = {"620105001":"培黎街道","620105002":"西路街道","620105003":"沙井驿街道","620105004":"十里店街道","620105005":"孔家崖街道","620105006":"银滩路街道","620105007":"刘家堡街道","620105008":"安宁堡街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620105.json
// module id = 2682
// module chunks = 0